// src/components/report/svg/AssessmentIconSVG.jsx with improved camera icon
import React from 'react';

const AssessmentIconSVG = ({type, size = 20, selected = false}) => {
    const commonProps = {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: selected ? "#F97316" : "#6B7280", // Orange-600 if selected, Gray-500 otherwise
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
    };

    switch (type) {
        case 'liked-yes': // Smiley face
            return (
                <svg {...commonProps} stroke={selected ? "#16A34A" : "#10B981"}> {/* Green tones */}
                    <circle cx="12" cy="12" r="10"/>
                    <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
                    <line x1="9" y1="9" x2="9.01" y2="9"/>
                    <line x1="15" y1="9" x2="15.01" y2="9"/>
                </svg>
            );
        case 'liked-no': // Frowny face
            return (
                <svg {...commonProps} stroke={selected ? "#DC2626" : "#EF4444"}> {/* Red tones */}
                    <circle cx="12" cy="12" r="10"/>
                    <path d="M8 15s1.5-2 4-2 4 2 4 2"/>
                    <line x1="9" y1="9" x2="9.01" y2="9"/>
                    <line x1="15" y1="9" x2="15.01" y2="9"/>
                </svg>
            );
        case 'easy-yes': // Similar to liked-yes
            return (
                <svg {...commonProps} stroke={selected ? "#16A34A" : "#10B981"}>
                    <circle cx="12" cy="12" r="10"/>
                    <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
                    <line x1="9" y1="9" x2="9.01" y2="9"/>
                    <line x1="15" y1="9" x2="15.01" y2="9"/>
                </svg>
            );
        case 'easy-no': // Similar to liked-no
            return (
                <svg {...commonProps} stroke={selected ? "#DC2626" : "#EF4444"}>
                    <circle cx="12" cy="12" r="10"/>
                    <path d="M8 15s1.5-2 4-2 4 2 4 2"/>
                    <line x1="9" y1="9" x2="9.01" y2="9"/>
                    <line x1="15" y1="9" x2="15.01" y2="9"/>
                </svg>
            );
        case 'dont-know': // Question mark face / Neutral
            return (
                <svg {...commonProps} stroke={selected ? "#F59E0B" : "#FBBF24"}> {/* Amber/Yellow tones */}
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="12" y1="16" x2="12" y2="16"/>
                    {/* Mouth as a dot or straight line */}
                    <path d="M12 12h.01"/>
                    <line x1="9" y1="9" x2="9.01" y2="9"/>
                    <line x1="15" y1="9" x2="15.01" y2="9"/>
                </svg>
            );
        // Resource Icons
        case 'classmate': // Users icon
            return <svg {...commonProps}>
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                <circle cx="9" cy="7" r="4"/>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>;
        case 'teacher': // User icon
            return <svg {...commonProps}>
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
            </svg>;
        case 'books': // BookOpen icon
            return <svg {...commonProps}>
                <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
                <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
            </svg>;
        case 'computer': // Monitor icon
            return <svg {...commonProps}>
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                <line x1="8" y1="21" x2="16" y2="21"/>
                <line x1="12" y1="17" x2="12" y2="21"/>
            </svg>;
        case 'none': // XCircle icon
            return <svg {...commonProps} stroke={selected ? "#DC2626" : "#EF4444"}>
                <circle cx="12" cy="12" r="10"/>
                <line x1="15" y1="9" x2="9" y2="15"/>
                <line x1="9" y1="9" x2="15" y2="15"/>
            </svg>;
        // Caregiver Icons
        case 'books/magazine': // Re-use books
            return <svg {...commonProps}>
                <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
                <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
            </svg>;
        case 'newspaper': // FileText icon (similar to newspaper)
            return <svg {...commonProps}>
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
                <line x1="16" y1="13" x2="8" y2="13"/>
                <line x1="16" y1="17" x2="8" y2="17"/>
                <polyline points="10 9 9 9 8 9"/>
            </svg>;
        case 'toys/games/sports': // Package / Box (for toys) or a simple ball
            return <svg {...commonProps}>
                <path
                    d="M12.54 2.14a1 1 0 0 0-1.08 0L2.7 7.75a1 1 0 0 0-.23.69v7.22a1 1 0 0 0 .5.87l8.67 4.95a1 1 0 0 0 1.08 0l8.67-4.95a1 1 0 0 0 .5-.87V8.44a1 1 0 0 0-.23-.69Z"/>
                <path d="m12 13.5-8.7-4.95"/>
                <path d="M12 13.5V22.5"/>
                <path d="M12 13.5 20.7 8.55"/>
                <path d="M21 8v7.2"/>
                <path d="m3.3 8.55 8.7 4.95"/>
            </svg>;
        case 'phone/computer': // Smartphone icon combined with monitor
            return <svg {...commonProps}>
                <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/>
                <path d="M12 18h.01"/>
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2" opacity="0.3"/>
                <line x1="8" y1="21" x2="16" y2="21" opacity="0.3"/>
                <line x1="12" y1="17" x2="12" y2="21" opacity="0.3"/>
            </svg>;
        case 'internet': // Globe icon
            return <svg {...commonProps}>
                <circle cx="12" cy="12" r="10"/>
                <line x1="2" y1="12" x2="22" y2="12"/>
                <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
            </svg>;
        case 'camera': // Enhanced Camera Icon for Part A-1
            return (
                <svg
                    {...commonProps}
                    strokeWidth="1.5"
                    className="photo-placeholder-icon"
                >
                    {/* Camera body */}
                    <rect x="1" y="5" width="22" height="14" rx="2" ry="2" stroke="#6B7280" fill="#E5E7EB"/>
                    {/* Lens */}
                    <circle cx="12" cy="13" r="4" stroke="#6B7280" fill="#D1D5DB"/>
                    <circle cx="12" cy="13" r="2" stroke="#6B7280" fill="#9CA3AF"/>
                    {/* Flash */}
                    <rect x="16" y="6" width="3" height="2" rx="1" stroke="#6B7280" fill="#D1D5DB"/>
                    {/* Camera top */}
                    <path d="M9 5 L7 2 L17 2 L15 5" stroke="#6B7280" fill="#9CA3AF"/>
                    {/* Button */}
                    <circle cx="18" cy="10" r="1" stroke="#6B7280" fill="#EF4444"/>
                    <text x="12" y="19.5" textAnchor="middle" fontSize="2.5" fill="#6B7280" fontWeight="bold">PHOTO
                    </text>
                </svg>
            );
        default:
            return <svg {...commonProps}>
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>; // Fallback: Info icon
    }
};

export default AssessmentIconSVG;